<template>
  <div>
    <br />
    <b-row>
      <b-col class="text-left">
        <h5 class="h5 text-primary">
          <b>Online Test</b>
        </h5>
      </b-col>
      <b-col class="text-right">
        <router-link :to="{name: 'createOnlineTest'}">
          <b-button variant="primary">
            <img class="mr-2" src="@/assets/create-new.svg" alt />Create New
          </b-button>
        </router-link>
      </b-col>
    </b-row>
    <div class="text-left">
      <br />
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <b-table
        v-else
        :busy="loading"
        responsive
        show-empty
        hover
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(test_name)="data">
          <label class="text-primary">{{data.value}}</label>
        </template>
        <template v-slot:cell(duration)="data">
          <label>{{data.value}}&nbsp;Minutes</label>
        </template>
        <template v-slot:cell(is_auto_grading)="data">
          <label>{{data.value == true ? 'Yes':'No' }}</label>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editOnlineTest', params: {id: item.id}}"
            class="text-dark"
          >
            <img class="mr-2" src="@/assets/ic-edit.svg" alt />
          </router-link>
          <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.id)">
            <img class="mr-2" src="@/assets/rectangle.svg" alt />
          </b-link>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{rows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'created_date',
          label: 'Created Date',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'test_name',
          label: 'Test Name',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'duration',
          label: 'Duration',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'question_and_answers',
          label: 'Questions',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'is_auto_grading',
          label: 'Auto Grade',
          sortable: true,
          class: 'text-left',
        },
        { key: 'action', label: 'Action', class: 'text-left' },
      ],
      loading: false,
      errored: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      customerShow: false,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    this.$store
      .dispatch('onlineTestModule/getOnlineTest')
      .then((response) => {
        this.loading = false;
      })
      .catch((error) => {
        this.$swal({
          type: 'error',
          title: 'Oops...',
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      });
  },
  created() {
    this.totalRows = this.items.length;
    this.$store.watch(
      state => state.onlineTestModule.onlinetest,
      (newValue, oldValue) => {
        this.items = newValue;
      },
    );
  },
  mounted() {},
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('onlineTestModule/delOnlineTest', id);
          this.$swal('Deleted!', 'Your file has been deleted.', 'success');
        }
      });
    },
  },
};
</script>

<style>
</style>
